import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { supabase } from '../../config/supabase';
import { API_BASE_URL } from '../../config/api';

const domains = ['localhost', 'readly-nu.vercel.app', 'scholarly-two.vercel.app', 'textly-ashen.vercel.app', '.uiuxify.com', '.scholarlytraining.com'];

export const AuthManager = ({ children }) => {
    const [session, setSession] = useState(null);
    const [loading, setLoading] = useState(true);

    const setTokens = (newSession) => {
        if (!newSession) return;
        // Set tokens in localStorage for API requests
        localStorage.setItem('token', newSession.access_token);
        localStorage.setItem('refreshToken', newSession.refresh_token);
    };

    const clearTokens = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('mongoToken');
    };

    useEffect(() => {
        const handleAuth = async () => {
            try {
                const { data, error: sessionError } = await supabase.auth.getSession();

                if (sessionError) {
                    throw sessionError;
                }
                console.log(data);
                if (!data.session) {
                    const accessToken = Cookies.get('sp-access-token');
                    const refreshToken = Cookies.get('sp-refresh-token');

                    if (accessToken && refreshToken) {
                        const { data: sessionData, error } = await supabase.auth.setSession({
                            access_token: accessToken,
                            refresh_token: refreshToken,
                        });

                        if (error) {
                            throw error;
                        } else {
                            setSession(sessionData.session);
                            setTokens(sessionData.session);
                        }
                    } else {
                        setSession(null);
                    }
                } else {
                    const { data: userData, error: userError } = await supabase.auth.getUser();

                    if (userError) {
                        throw userError;
                    }

                    if (!userData.user) {
                        throw new Error("No user found in session");
                    }

                    setSession(data.session);
                    setTokens(data.session);
                }
            } catch (error) {
                setSession(null);
                domains.forEach(domain => {
                    Cookies.remove('sp-access-token', { path: '/', domain });
                    Cookies.remove('sp-refresh-token', { path: '/', domain });
                });
            } finally {
                setLoading(false);
            }
        };

        handleAuth();

        const { data: { subscription } } = supabase.auth.onAuthStateChange((event, newSession) => {
            if (event === 'SIGNED_OUT' || event === 'USER_DELETED') {
                clearTokens();
                domains.forEach(domain => {
                    Cookies.remove('sp-access-token', { path: '/', domain });
                    Cookies.remove('sp-refresh-token', { path: '/', domain });
                });

                setSession(null);
            } else if (event === 'SIGNED_IN' || event === 'TOKEN_REFRESHED') {
                const cookieOptions = {
                    expires: 365,
                    path: '/',
                    sameSite: 'None',
                    secure: true
                };

                domains.forEach(domain => {
                    Cookies.set('sp-access-token', newSession.access_token, { ...cookieOptions, domain });
                    Cookies.set('sp-refresh-token', newSession.refresh_token, { ...cookieOptions, domain });
                });

                setSession(newSession);
                setTokens(newSession);
            }
        });

        return () => subscription.unsubscribe();
    }, []);

    return children({ session, loading });
};